import { render, staticRenderFns } from "./CommunityActivity.vue?vue&type=template&id=13911608&scoped=true&"
import script from "./CommunityActivity.vue?vue&type=script&lang=js&"
export * from "./CommunityActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13911608",
  null
  
)

export default component.exports